import get from 'lodash.get';
import Breakpoints from 'lib/Breakpoints';
import getConfig from 'next/config';
import fetch from 'isomorphic-fetch';

import { TAX_CONSTANTS } from 'lib/taxonomy';

const ASPECT_1X1 = 'ASPECT_1X1';
const ASPECT_2X1 = 'ASPECT_2X1';
const { TODAY: { GIFT_GUIDE: GIFT_GUIDE_TAX_PATH } } = TAX_CONSTANTS;

const getLimit = (props) => {
  const {
    isGiftGuide, isTrending, isNBCNewsCommerce, isBetterNewsCommerce,
  } = props;

  if (isNBCNewsCommerce || isTrending || isGiftGuide || isBetterNewsCommerce) {
    return 4;
  }

  return Breakpoints.isS() ? 1 : 2;
};

/**
 * Formatter function for getFormattedItems
 */
export const formatRecommendationItem = (item) => {
  const { id, type } = item;
  const alternateTeaseImages = get(item, ['alternateTeaseImages']) || [];
  const thumbnail1x1 = alternateTeaseImages.find(
    ({ aspectRatio }) => aspectRatio === ASPECT_1X1,
  );
  const thumbnail2x1 = alternateTeaseImages.find(
    ({ aspectRatio }) => aspectRatio === ASPECT_2X1,
  );

  const primaryThumbnail = get(thumbnail1x1, ['image', 'url', 'primary'], null);
  const secondaryThumbnail = get(thumbnail2x1, ['image', 'url', 'primary'], null);
  const defaultThumbnail = get(item, ['primaryImage', 'url', 'primary']);
  const thumbnail = primaryThumbnail || secondaryThumbnail || defaultThumbnail;

  const unibrow = {
    url: get(item, ['unibrow', 'url']),
    text: get(item, ['unibrow', 'text']),
  };
  const title = get(item, ['headline', 'tease']);
  const url = get(item, ['url', 'primary']);

  return {
    id,
    url,
    type,
    title,
    unibrow,
    thumbnail,
  };
};

const formatPayload = (payload) => {
  const items = payload?.data?.search?.items ?? [];

  if (!items.length) {
    // eslint-disable-next-line no-console
    console.warn('RamenRecommendedComponent: No valid items returned from bentoAPI');
  }

  return items.map(formatRecommendationItem);
};

export const fetchAndSetFormattedItems = (props, setItems) => {
  const { isRightRail, isGiftGuide, articleID } = props;
  const { publicRuntimeConfig: { API_URL_BENTO_PUBLIC } } = getConfig();
  const articlePrimaryTaxPath = get(props, ['taxonomy', 'primaryTopic', 'path'], GIFT_GUIDE_TAX_PATH);
  const taxonomyFilter = isGiftGuide ? GIFT_GUIDE_TAX_PATH : articlePrimaryTaxPath;
  const size = getLimit(props);
  // For gift guide components that are NOT on gift guide articles, we can safely fetch the
  // first page, since there is no risk of conflict with the right rail items.
  const page = isRightRail || articlePrimaryTaxPath !== GIFT_GUIDE_TAX_PATH ? 1 : 2;
  const query = `type:article AND NOT id:${articleID} AND taxonomy:${taxonomyFilter}`;
  const apiEndpoint = `${API_URL_BENTO_PUBLIC}/commerceRecommended?query=${query}&page=${page}&size=${size}`;

  fetch(apiEndpoint)
    .then((res) => res.json())
    .then(formatPayload)
    .then(setItems)
    // eslint-disable-next-line no-console
    .catch(console.error);
};

/**
 * Certain article types do not get gift guide components, and small screens do not have the room.
 */
export const shouldShowRelatedContent = (props) => {
  const {
    mobile,
    isTrending,
    isGiftGuide,
    isNBCNewsCommerce,
    isBetterNewsCommerce,
  } = props;
  if (isTrending || isGiftGuide || isNBCNewsCommerce || isBetterNewsCommerce) {
    return true;
  }
  return (mobile && Breakpoints.isSorM()) || (!mobile && Breakpoints.isLorXL());
};
